import './App.css';
import React from 'react'

const keyArr = [
  {
    name:"A0",
    url: "https://dl.dropbox.com/s/g7fhwqdxgk8ormr/A0.mp3?dl=0"
  },
  {
    name:"B0",
    url: "https://dl.dropbox.com/s/8il0nc2izui81qg/B0.mp3?dl=0"
  },
  {
    name:"C1",
    url: "https://dl.dropbox.com/s/96szr7auptjoygo/C1.mp3?dl=0"
  },
  {
    name:"D1",
    url: "https://dl.dropbox.com/s/h4hy5b0uhdujyzu/D1.mp3?dl=0"
  },
  {
    name:"E1",
    url: "https://dl.dropbox.com/s/b3446adwvj0poep/E1.mp3?dl=0"
  },
  {
    name:"F1",
    url: "https://dl.dropbox.com/s/g8mexiv1fxt8uko/F1.mp3?dl=0"
  },
  {
    name:"G1",
    url: "https://dl.dropbox.com/s/kgujbduinofkuu4/G1.mp3?dl=0"
  },
  {
    name:"A1",
    url: "https://dl.dropbox.com/s/d1c2780ep7ddvd1/A1.mp3?dl=0"
  },
  {
    name:"B1",
    url: "https://dl.dropbox.com/s/7j9a5mwow99lflb/B1.mp3?dl=0"
  }
];

function App() {
  return (
    <div className="App">
      <DrumMachine />
    </div>
  );
}

class DrumMachine extends React.Component{
  
  constructor(props){
    super(props)

    this.state = {
      display: String.fromCharCode(160),
      volume: 50
    }
    this.onSliderChange = this.onSliderChange.bind(this);
    this.updateDisplay = this.updateDisplay.bind(this);
  }

  onSliderChange(e){
    this.setState({
      volume: e.target.value
    });
    this.setVolume();
    this.updateDisplay("Volume: " + this.state.volume);
    setTimeout(() => this.updateDisplay(String.fromCharCode(160)), 1000)
  }

  setVolume(){
    let audio = document.querySelectorAll("audio");
    audio.forEach(item => {
      item.volume = this.state.volume/100;
    });
    
  }

  updateDisplay(name){
    this.setState({
      display: name
    })
  }

  render(){
   
    return(
      <div id="drum-machine">
        <PadBank updateDisplay={this.updateDisplay}/>
        <div id="display-container">
          <p id="display">{this.state.display}</p>
          <div className="slidecontainer">
            <input type="range" min="1" max="100" value={this.state.volume} className="slider" onChange={this.onSliderChange} onClick={this.onSliderChange}/>
          </div>
        </div>
      </div>
    )
  }

}

class PadBank extends React.Component{

  constructor(props){
    super(props)
    this.state = {
      keys:  ["Q","W","E","A","S","D","Z","X","C"]
    }
  }

  render(){
    let pads = this.state.keys.map((value,index) => {
      return (
        <DrumPad key = {value} keyTrigger={value} audio={keyArr[index]} updateDisplay={this.props.updateDisplay} />
      )
    });

    return(
      <div id="drum-container">
        {pads}
      </div>
    )
  }
}

class DrumPad extends React.Component{
  
  constructor(props){
    super(props);
    this.playAudio = this.playAudio.bind(this);
    
  }

 

  componentDidMount(){
    let down = false;
    document.addEventListener('keydown', event => {
      if(down){
        console.log("returning");
        return
      }
      if (event.code.includes(this.props.keyTrigger)){
        down=true;
        this.playAudio()
      }
    })

    document.addEventListener('keyup', () =>{
      down = false;
    })
   
  }

 

  playAudio(){
    let audio = document.getElementById(this.props.keyTrigger);
    let button = audio.parentElement;
    
    button.classList.add("button-active");
    audio.currentTime = 0;
    audio.play();
    
    //display the name of the sound played 
    this.props.updateDisplay(this.props.audio.name);

    setTimeout(()=>button.classList.remove("button-active"), 200);
    
    
  }

  render(){
    
    return (
      <button className= "drum-pad" key={this.props.keyTrigger}  onClick={this.playAudio}>
          <audio src={this.props.audio.url} id={this.props.keyTrigger}>
          </audio>
          <p>{this.props.keyTrigger}</p>
      </button>
    )

  }
}

export default App;
